<template>
  <form ref="form" class="birthday_nomination_form" method="post" action="https://australia-southeast1-foxtware.cloudfunctions.net/apexShopifyCustomerInfoUpdate" @submit.prevent="submit" :class="{ _thankyou: thankyou }">
    <div class="bday_nom_inner">
      <h2 class="account_title">Is it your bday?</h2>
      <p>It looks like we don't know your birthday! Enter it here so we can celebrate with you:</p>
      <div class="birthday_nomination_form_submit_wrapper">
        <birth-date-field ref="field" name="birth_date" :max="max" :data-mask="bday_format" data-autofill-chars="/-"></birth-date-field>
        <button type="submit" class="btn btn-primary" v-html="buttonHtml" :disabled="busy" @click="submitAttempted">Update</button>
      </div>
      <div class="bday_nom_thankyou_message">
        Thanks babe! 
        <p>Did you know that Loyalty Club members Level 1+ get a discount on their birthday? If that's you, keep an eye out!</p>
      </div>
    </div>
  </form>
</template>

<script>
  export default {
    name: 'birthday_nomination_form',
    props: ['bday_format', 'token', 'value', 'region', 'max'],
    data() {
      return {
        buttonHtml: 'Update',
        busy: false,
        thankyou: false,
      };
    },
    methods: {
      submitAttempted: function() {
        console.log('submitAttempted');
        const { field } = this.$refs;
        field.classList.add('_submit_attempted');
      },
      submit: async function(e) {
        if (this.busy) {
          console.warn('Take a deep breath');
          return;
        }

        const { form } = this.$refs;

        const formData = new FormData(form);
        const formDataObj = Object.fromEntries([...formData]);
        console.log(formDataObj);

        const { birth_date } = formDataObj;

        this.busy = true;
        this.buttonHtml = '...';

        const [
          minTime, 
          result,
        ] = await Promise.all([
          this.wait(2000),
          this.makeRequest('birth_date', birth_date),
        ]);

        const successful = result && !result?.userErrors?.length;

        if (successful) {
          this.buttonHtml = 'Done!';
          await this.wait(1000);

          // Show thank you message
          this.thankyou = true;

          return;
        }

        alert(`Sorry babe, something went wrong, try again in a few.`);

        this.buttonHtml = ' '; // Error
        await this.wait(1000);
        this.busy = false;
        this.buttonHtml = 'Update';
      },
      makeRequest: async function(target, payload) {
        const { form } = this.$refs;
        const { method, action } = form;

        let response;
        try {
          response = await fetch(action, {
            method,
            headers: {
              'Content-Type': 'application/json',
              'x-wf-token': this.token,
              'x-wf-value': this.value,
            },
            body: JSON.stringify({
              config: this.region,
              customerId: this.value,
              target,
              payload,
            }),
          });

          if (!response?.ok) {
            return false;
          }

          if (response?.error) {
            return false;
          }

          return true;
        } catch(err) {
          alert(`Soz babe, network error, please check your connection and try again.`);
          console.error('Network error', err);

          return false;
        }
      },
      wait: ms => new Promise((resolve, reject) => setTimeout(resolve, ms)),
    },
  }
</script>